module.exports = __webpack_public_path__ + "static/media/logo.db989a56.jpg";